import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import { State } from '../../typings/state';
import { TDispatchProps } from '../../typings/utils';
import { BatchesListState } from '../BatchesList/typings';
import { Order } from '../common/typings';
import {
    applySizesFilter,
    hideCreativesSelector,
    hideError,
    Html5CreativesAction,
    loadItems,
    showCreativesSelector
} from '../Html5App/actions';

import { Html5Archive } from './Html5Archive';
import { FilterState, Html5ArchiveProps, OwnProps } from './typings';

type DispatchProps = TDispatchProps<Html5ArchiveProps, OwnProps>;
const mapDispatchToProps = (dispatch: Dispatch<Html5CreativesAction>): DispatchProps => {
    return {
        loadItems: (offset: number, order: Order, sizes: string[], filterText: string) =>
            dispatch(loadItems(offset, order, sizes, filterText)),
        applySizesFilter: (sizes: string[]) => dispatch(applySizesFilter(sizes)),
        hideError: () => dispatch(hideError()),
        showCreativesSelector: (id: string) => dispatch(showCreativesSelector(id)),
        hideCreativesSelector: () => dispatch(hideCreativesSelector())
    };
};

type StateProps = {
    filter: FilterState;
    batchesList: BatchesListState;
    error: { message: string } | undefined;
    isBusy: boolean;
    needRefresh: boolean;
};
export const mapStateToProps = (state: State): StateProps => {
    return {
        ...state.canvasEditor.html5.archiveCreatives,
        error: state.canvasEditor.html5.error,
        isBusy: state.canvasEditor.html5.isBusy
    };
};

export const Html5ArchiveContainer = connect<StateProps, DispatchProps, OwnProps>(
    mapStateToProps,
    mapDispatchToProps
)(Html5Archive);
